export const isInVisualEditor = () => {
  return (
    typeof window !== 'undefined' &&
    window?.location?.search?.includes?.('_storyblok')
  );
};
